import Box from '@mui/material/Box'
import { Modal, CircularProgress, Error, Generating } from '../components'
import texts from '../texts'
import styles from './context.styles'

interface ContextProps {
  title: string
  open: boolean
  onClose: () => void
  isLoading: boolean
  isGenerating?: boolean
  error: boolean
  data?: TrustedHTML | null
}

const Context = ({
  title,
  open,
  onClose,
  isLoading,
  isGenerating,
  error,
  data,
}: ContextProps) => {
  return (
    <Modal open={open} onClose={onClose} title={title}>
      {isLoading ? (
        <CircularProgress />
      ) : isGenerating ? (
        <Generating
          phrases={texts.getGeneratingPhrases('contexto')}
        />
      ) : error ? (
        <Error
          title={texts.getGenerationErrorTitle('contexto')}
          text={texts.getGenerationErrorSubtitle()}
        />
      ) : (
        <Box sx={styles.content}
          dangerouslySetInnerHTML={{
            __html: data as TrustedHTML,
          }}
        />
      )}
    </Modal>
  )
}

export default Context
